module.exports = __webpack_public_path__ + "static/media/service-station.689c6f91.svg";